import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 28
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('masterElectroEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
        localStorage.setItem('masterElectroEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
      localStorage.setItem('masterElectroEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
        localStorage.setItem('masterElectroEndTime', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center space-x-2 font-montserrat font-black text-2xl md:text-4xl text-brand-text ${className}`} data-id="element-39">
      <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg border-2 border-brand-danger shadow-md min-w-[60px] md:min-w-[80px] text-center" data-id="element-40">
        <span className="text-brand-danger" data-id="element-41">{fmt(timeLeft.hours)}</span>
        <div className="text-[10px] md:text-xs text-brand-steel uppercase tracking-wider mt-1" data-id="element-42">
          Horas
        </div>
      </div>
      <span className="text-brand-danger animate-pulse pb-4" data-id="element-43">:</span>
      <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg border-2 border-brand-danger shadow-md min-w-[60px] md:min-w-[80px] text-center" data-id="element-44">
        <span className="text-brand-danger" data-id="element-45">{fmt(timeLeft.minutes)}</span>
        <div className="text-[10px] md:text-xs text-brand-steel uppercase tracking-wider mt-1" data-id="element-46">
          Min
        </div>
      </div>
      <span className="text-brand-danger animate-pulse pb-4" data-id="element-47">:</span>
      <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg border-2 border-brand-danger shadow-md min-w-[60px] md:min-w-[80px] text-center" data-id="element-48">
        <span className="text-brand-danger" data-id="element-49">{fmt(timeLeft.seconds)}</span>
        <div className="text-[10px] md:text-xs text-brand-steel uppercase tracking-wider mt-1" data-id="element-50">
          Seg
        </div>
      </div>
    </div>;
}